export const locale = {
    lang: 'pl',
    data: {
        'Products': 'Produkty',
        'Sale': 'Sprzedaż',
        'Deliveries': 'Dostawy',
        'New': 'Nowy',
        'Edit': 'Edycja',
        'Name': 'Nazwa',
        'Category': 'Kategoria',
        'Barcode': 'Kod kreskowy',
        'Stock': 'Stan magazynowy',
        'Price gross': 'Cena brutto',
        'Actions': 'Akcje',
        'Product data': 'Dane produktu',
        'Name is required!': 'Nazwa jest wymagana',
        'Is product': 'Produkt',
        'Is material': 'Materiał',
        'Add category': 'Dodaj kategorię',
        'Manufacturer': 'Producent',
        'Add manufacturer': 'Dodaj producenta',
        'Price net': 'Cena netto',
        'Vat rate': 'VAT',
        'Minimal stock': 'Minimalny stan magazynowy',
        'Unit': 'Jednostka',
        'Purchase price gross': 'Cena brutto zakupu',
        'Purchase price net': 'Cena netto zakupu',
        'Description': 'Opis',
        'Save': 'Zapisz',
        'no category': 'brak kategorii',
        'Sell': 'Sprzedaj',
        'Length': 'Długość',
        "No possibility to sell!": "Brak możliwości sprzedaży karnetu!",
        "Name for receipt is empty": "Nazwa dla paragonu jest pusta",
        "Cash reports": "Raporty kasowe",
        "Name for receipt": "Nazwa na paragonie",
        "Sale report": "Raport sprzedaży",
        "Logs": "Logi",
    }
};
